import { queryClient } from "@/api/constants"

type TrackingProjectSummary = {
	id: string
	isSampleProject?: boolean
}

function getTrackedProjectIsSample(projectId: unknown): boolean | undefined {
	if (typeof projectId !== "string" || projectId.length === 0) {
		return undefined
	}

	const projects = queryClient.getQueryData<TrackingProjectSummary[]>(["projects"])
	return projects?.find((project) => project.id === projectId)?.isSampleProject
}

export function enrichProjectTrackingProperties(customProperties: Record<string, unknown>) {
	const hasProjectId = Object.prototype.hasOwnProperty.call(customProperties, "projectId")
	if (!hasProjectId || typeof customProperties.isSampleProject === "boolean") {
		return
	}

	customProperties.isSampleProject =
		getTrackedProjectIsSample(customProperties.projectId) === true
}
